import React, { useState, useEffect } from "react";
import { Col, Row, Accordion, Card, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  changeCampaignsModal,
  requestNumbersAvailable,
  requestPurchaseNumber,
  resetNumbersAvailable,
} from "../../../../../redux/actions/campaigns";
import {
  FadeButton,
  SolidButton,
  TransparentButton,
} from "../../../../library/button";
import { Input } from "../../../../library/input";
import { Label } from "../../../../library/label";
import { Popup } from "../../../../library/popup";
import { countries } from "../../../../../resources/countries.json";
import { Select } from "../../../../library/select";
import { Checkbox } from "../../../../library/checkbox";
import ReactCountryFlag from "react-country-flag";
import { TableLoader } from "../../../../library/table-loader";
import emptyAnimation from "../../../../../resources/empty-animation.json";
import Lottie from "react-lottie-player";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();

  const modalState = useSelector(
    (state) => state.campaigns.showModals.purchaseNumberModal
  );
  const companyId = useSelector(
    (state) =>
      state &&
      state.activeCompany &&
      state.activeCompany.activeCompany &&
      state.activeCompany.activeCompany.id
  );
  const activeChannel = useSelector((state) => state.campaigns.activeChannel);

  const loading = useSelector(
    (state) => state.campaigns.fetchNumberOptions.loading
  );
  const options = useSelector(
    (state) => state.campaigns.fetchNumberOptions.details
  );
  const error = useSelector(
    (state) => state.campaigns.fetchNumberOptions.error
  );

  const purchaseLoading = useSelector(
    (state) => state.campaigns.purchaseNumber.loading
  );

  const [selectedNumber, setSelectedNumber] = useState(undefined);

  const [activeTab, setActiveTab] = useState("0");

  const [searchQuery, setSearchQuery] = useState({
    country: "NO",
    sms: null,
    voice: null,
  });

  const handleClose = () => {
    dispatch(changeCampaignsModal({ purchaseNumberModal: false }));
  };

  const renderCountries = () => {
    const items = [
      {
        id: 0,
        value: "",
        title: "Velg",
        selected: true,
        disabled: false,
      },
      {
        id: 1,
        value: "SE",
        title: "Sverige",
        selected: searchQuery.country === "SE" ? true : false,
        disabled: false,
      },
    ];
    return items;
  };

  useEffect(() => {
    dispatch(
      requestNumbersAvailable({
        companyId: companyId,
        channelId: activeChannel.id,
        search: searchQuery,
      })
    );
  }, [searchQuery]);

  useEffect(() => {
    if (error && options && options.length > 0) {
      dispatch(resetNumbersAvailable());
    }
  }, [error]);

  const clickPurchaseNumber = (details) => {
    setSelectedNumber(details.number);
    dispatch(
      requestPurchaseNumber({
        companyId: companyId,
        channelId: activeChannel.id,
        number: details,
      })
    );
  };

  const renderList = () => {
    if (!loading && options && options.length > 0) {
      return options.map((option) => (
        <div className="single-option-container">
          <Row className="single-option-row">
            <Col className="details-col my-auto">
              <span className="number-label">{option.number}</span>
              <span className="area-label">
                {option.locality ? option.locality : "Uvisst område"}
              </span>
            </Col>
            <Col className="price-col my-auto">
              <span className="price-label">59kr</span>
              <span className="duration-label">per mnd</span>
            </Col>
            <Col className="button-col text-right my-auto">
              <FadeButton
                onClick={() => clickPurchaseNumber(option)}
                size="xs"
                color="green"
                title={
                  selectedNumber === option.number && purchaseLoading
                    ? "Laster.."
                    : "Kjøp"
                }
              />
            </Col>
          </Row>
        </div>
      ));
    }
    if ((!loading && !options) || (options && options.length === 0)) {
      return (
        <div className="empty-options-container">
          <div className="inner-empty-options-container">
            <p className="empty-label">
              Kunne ikke hente noen nummere fra valgt land. Prøv å velg et annet
              land for å få opp flere alternativer.
            </p>
          </div>
        </div>
      );
    }
    return null;
  };

  const handleSelect = (val) => {
    setSearchQuery({ ...searchQuery, country: val });
    setActiveTab("1");
  };

  return (
    <Popup
      onClose={handleClose}
      show={modalState}
      title="Kjøp nummer"
      description="Kjøp et telefonnummer for utsendelse av SMS og bestem hvilket nummer og landkode du ønsker."
    >
      <div className="purchase-number-content-container">
        <Accordion
          className="phone-number-accordion"
          defaultActiveKey="0"
          activeKey={activeTab}
        >
          <Card className="single-card top">
            <Card.Header className="card-header">
              <Accordion.Toggle
                className="card-toggle"
                as={Button}
                variant="link"
                eventKey="0"
                onClick={() => setActiveTab("0")}
              >
                Velg et land <i class="fad fa-chevron-down"></i>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body className="card-body">
                <Row className="info-row">
                  <Col className="info-col">
                    <Select
                      onChange={(e) => handleSelect(e.target.value)}
                      items={renderCountries()}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card className="single-card bottom">
            <Card.Header className="card-header">
              <Accordion.Toggle
                className="card-toggle"
                as={Button}
                variant="link"
                eventKey="1"
                onClick={() => setActiveTab("1")}
              >
                Tilgjengelige nummere <i class="fad fa-chevron-down"></i>
              </Accordion.Toggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <Card.Body className="card-body">
                <div className="notification-container">
                  <p>
                    Du kan sende sms og ringe fra hvilket som helst nummer uten
                    å avsløre det virkelige nummeret gjennom maskering. Les mer
                    om dette her.
                  </p>
                </div>
                <Row className="info-row">
                  <Col className="info-col">
                    <Row className="title-row">
                      <Col className="title-col">
                        <Label version={1} weight="bold">
                          Nummer
                        </Label>
                      </Col>
                      <Col className="title-col price">
                        <Label version={1} weight="bold">
                          Pris
                        </Label>
                      </Col>
                      <Col className="title-col text-right">
                        <Label version={1} weight="bold">
                          Handling
                        </Label>
                      </Col>
                    </Row>
                    {loading && <TableLoader />}
                    <div className="option-selection-container">
                      {renderList()}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </div>
      <ToastContainer />
    </Popup>
  );
};

export default Index;
